/* eslint-disable max-len */

export default {
  lang: 'English',
  homeScreen: {
    title: '', // Product specific
    stayConnected: 'Stay Connected',
    comingSoon: 'Coming Soon',
    messages: 'Messages',
    subtitle: 'Live Boricua',
  },
  loginScreen: {
    version2: {
      homeTitle:
        "Let's see if we can find an existing profile for you in our system.",
      homeTitleSub:
        'Enter the email address you typically use to login to training programs.',
      noAccount:
        'No account found ({email}), please try with another email or create an account now.',
      continueButton: 'Continue',
      success:
        'Successfully updated your account! You will be redirected shortly to the home page.',
      successNewAccount:
        'To complete your registration, you will receive a confirmation email to verify your account.',
      loginButton: 'Login',
      matchFound:
        'We have found a match, please fill in your password to continue.',
      magicLink: 'Login via a link in your email:',
      magicLinkButton: 'Request Magic Link',
      magicLinkTitle:
        'Get a direct link sent to your email that will sign you in instantly.',
      otherEmailButton: 'Submit',
      title:
        'Please take a moment to complete all the information below as it will populate your personal profile and contact information.',
      titleIndustry:
        'Please take a moment to complete all the information below as it will populate your personal profile and contact information.',
      register: 'Create an account',
      agent: 'Travel Advisor',
      visitor: 'Industry Visitor',
      step1: 'Step 1: Type of User',
      step2: 'Step 2: Create An Account',
      step3: 'Step 3: Create Your Profile',
      marketingOptIn:
        'Are you sure you are not interested in staying connected to this program’s travel trade team?',
      optIn: 'Yes, I’m Interested',
      optOut: 'Not Interested',
      step2Sub1: 'Tell Us About Yourself',
      step2Sub2: 'Tell Us About Your Business',
      privacyHead: 'COMMUNICATIONS PREFERENCES',
      privacySub:
        'Check the boxes below to ensure you receive important communications from the supplier’s travel trade team (product updates and announcements, rewards, incentives, FAMs, etc.) and travel trade networking and sales support initiatives from TravPRO Mobile.',
      privacy:
        'We protect your privacy and never sell, misuse or betray your trust.',
      store: 'Easily download this program at your app store:',
      powered: 'POWERED BY',
      toastMessage: {
        forgotSuccess:
          'We have e-mailed your password reset link! You will be redirected to the login page in 10 seconds.',
        emailNotExisting: "The email address you entered doesn't exist.",
        magicLinkMessage: 'Please wait, we are signing you in right now.',
        magicLinkError:
          "We couldn't find your account in our database, please log in manually. You will be redirected in 10 seconds.",
        magicLinkError1:
          "We couldn't find a valid token, please login or request a new magic link. If this problem persists, please contact us at: info@travpromobile.com.",
        magicLinkError2:
          "We couldn't find your account in our database, please log in manually. You will be redirected in 10 seconds.",
        magicLinkSuccess:
          "Check your email at {email}. It has a magic link that'll sign you in.",
        magicLinkErrorWait:
          'Please wait 5 minutes in between magic link requests.',
        emailNotFoundError:
          'The email address you entered can’t be found in our records. Please check for misspellings or create an account.',
      },
      errors: {
        zipCodeNotFound: 'ZipCode not found, try again',
        zipCodeOnlyNumbers: 'ZipCode can only contain numbers',
        password: 'Please enter a password',
        passwordNotMatching: 'The passwords you entered do not match',
        passwordTooShort: 'Password needs to be at least 8 characters',
        emailExists:
          'This email address already exists or is invalid. Please try with another email address or login to your account.',
        fillInAllFields: 'Please fill in all the required fields',
        fillInEmail: 'Please fill in your email.',
        emailNotExisting: "The email address you entered doesn't exist.",
      },
      fields: {
        forgotSubCopy: 'Forgot your password & want to change it? ',
        forgotSubCopy2:
          'Want to bypass password entirely? We will send you an email with a magic link that will automatically log you into the program. ',
        city: 'City',
        companyName: 'Company Name',
        role: 'Your Role',
        description: "Which best describes your company's business?",
        country: 'Country',
        password: 'Password',
        passwordRegister: 'Choose Password (8 character minimum)',
        passwordConfirm: 'Confirm Password',
        firstName: 'First Name (Given)',
        lastName: 'Last Name (Family)',
        agency: 'Your Agency Name',
        title: 'Your Role (Select One)',
        company: 'Company Name',
        select: 'Select an option below',
        state: 'State',
        province: 'Province/Region/State',
        zipCode: 'Zip Code',
        postalCode: 'Postal Code',
        affiliate: 'Which group is your MAIN agency affiliation?',
        hostAgency: 'Your Host Agency?',
        executive: 'Executive',
        management: 'Management',
        marketing: 'Marketing',
        sales: 'Sales',
        coordinator: 'Coordinator',
        other: 'Other ',
        opt: 'Stay connected to {program_name} trade team and receive updates.',
        optMarketing:
          'Stay connected to TravPRO regarding similar programs and events.',
        retail: 'Retail Store Front',
        home: 'Home-Based Agent',
        independent: 'Independent Contractor',
        host: 'Host Agency',
        call: 'Call Center or Web-Based Agency',
        describes: 'What best describes you and your agency’s business? ',
      },
    },
    title: 'Travel Professional Training and Sales Enablement Program', // Product specific (TravPRO text or ChannelPRO text)
    welcome: {
      headerTop: 'Welcome to the',
      headerBottom: '{program_name}', // Product specific
    },
    sellingPoints: {
      // All selling points can be product specific
      0: 'Learn, Promote & Sell on the Go',
      1: 'Multi-media Training Across Devices',
      2: 'Certificate of Completion',
      3: 'Ready-made Sales Presentations',
      4: 'High-impact Promotional Materials',
      5: 'Insider Tips & Promotions',
      6: 'Real-time Product Directory',
      7: 'Timely News & Updates',
    },
    emailPrompt:
      'Please enter your email address and password to confirm that you are a travel professional.', // Product specific (TravPRO or ChannelPRO text)
    tAndC: {
      agree: 'By continuing you agree with our ',
      privacyPolicy: 'privacy policy',
      and: ' and ',
      termsConditions: 'terms and conditions',
    },
    fields: {
      what: 'What type of travel do you sell?',
      what1: 'What is the #1 type of travel you sell?',
      what2: 'What is the #2 type of travel you sell?',
      what3: 'What is the #3 type of travel you sell?',
      agency: 'Agency *',
      email: 'Email',
      password: 'Password',
      passwordConfirm: 'Confirm your password *',
      firstName: 'First name *',
      lastName: 'Last name *',
      agencyName: 'Agency Name *',
      city: 'City *',
      stateProvince: 'State / Province *',
      salutation: 'Salutation *',
      required: 'Required',
      invalidEmail: 'Invalid email address',
      opt: "Stay In Touch! Yes, I'd like to opt in to communications from {client_name} that will keep me posted on news, events, incentives, FAM’s and more!",
      complete: 'Step 2: Complete your profile',
      tell: 'Tell Us About Yourself',
      title: 'Business Title *',
      host: 'Host Agency Name',
      country: 'Country / Region',
      select: 'Please select an option below',
      header2: 'Which segment(s) do you primarily sell?',
      step2: 'Describe Your Business',
      leisure: 'Leisure',
      corporate: 'Corporate',
      group: 'Group',
      affiliate: 'What is Your Main Affiliation?',
      forgot:
        'Forgot your password? Click the button below and we’ll send you an email to reset your password.',
    },
    noAgent: {
      noAgentButton: "I'm not an advisor",
      title: 'Thank you for your interest in\n{program_name}', // Product specific
      messageWeb:
        'The content on this site is exclusively for travel professionals.\nTo learn more about {program_name}, please visit: ', // Product specific
      messageMobile:
        "Some content on this app is exclusively for travel professionals, but feel free to browse a preview of what this app has to offer by pressing 'Continue'.", // Product specific
      continue: 'Continue',
      visitWebsite: 'Visit website',
    },
    newUser: 'New User',
    register: 'Register',
    registered: 'This email is already registered',
    forgot: 'Reset Password',
    header:
      'Please take a moment to complete all the information below, as this is what will populate your profile and contact information.',
    step1: 'Step 1: Complete your email address and choose a password.',
  },
  welcomeScreen: {
    title: 'Welcome to {program_name}', // Product specific
    helloUser: 'Hello {{name}}',
    hello: 'Hello,',
    fromAgency: 'from {{agency}}',
    notUser: 'Not {{name}}?',
    introOnline:
      "Train immediately online or preload the content so it's always available for offline use!",
    introOffline:
      'You already have the latest version preloaded. Start training or selling anytime, anywhere!',
    startTraining: 'Start learning',
    continueTraining: 'Continue learning',
    graduated: 'Congratulations!',
    downloader: {
      preload: 'Preload',
      stop: 'stop',
      init: 'Initializing...',
      lastUpdate: 'Last update: ',
    },
  },
  trainingScreens: {
    start: 'Start',
    continue: 'Continue',
    review: 'Review',
    restart: 'Restart',
    durationInMinutes: '{number} minutes',
    percentageComplete: '{number}% Complete',
    unlock: 'Unlock this chapter by completing training chapter {number}.',
    unlockSpecialization: 'Unlock this chapter by completing The Foundation',
    unlockSubtitle: 'Unlock more chapters by completing training chapters.',
    allUnlocked: 'You have unlocked all chapters!',
    certificate: 'Certificate',
    courseComplete: 'Continue',
    endReached: "You've reached the end",
    retainEnd:
      'Use the top bar to navigate around in this chapter or press the back button to return to the overview.',
    watchListenRead: 'Watch, Listen & Read more',
    trouble:
      "It looks like you're having trouble, please re-read the content on the previous page(s) and try again.",
    confirm: 'Confirm your answer',
    choose: 'Please choose an answer',
    skip: 'Return >',
    viewAllTitle: 'Training Tip',
    viewAll:
      'In order to proceed to the next page, please click on the icons to view the supplementary content. Videos, maps and other helpful information have been provided to enhance your training and ensure you achieve PRO status.',
    fillBlanks: 'Fill in the blank(s):',
    next: 'Next question',
    retry: 'Try Again',
    fastTrackText: {
      success:
        "Congratulations, you've passed the Fast Track course and unlocked the rest of the training!",
      failed:
        "Unfortunately you didn't pass the Fast Track course, you can resume your training to earn your diploma!",
    },
    fastTrack: 'Become a Swiss Travel Superstar!',
    fastTrackExplanation:
      'Simply take the quiz on the following pages for your chance to win a FAM to Switzerland!<br><br><span style="font-weight: bold">You will find all answers to the quiz questions in the following ways:</span><br><br>1.	The content that you learned in the Rail Europe and Switzerland modules<br><br>2.	And on the following websites:<br><a href="https://www.myswitzerland.com" target="_blank">www.myswitzerland.com</a><br><a href="https://www.bucherer.com" target="_blank">www.bucherer.com</a><br><a href="https://www.mysts.net" target="_blank">www.mysts.net</a><br><br><span style="font-weight: bold">Be sure to review these resources in detail before taking the quiz! Only those with the highest of scores will have the chance to be invited to the FAM.</span>',
    fastTrackButton: 'Click Here to Take the Swiss Superstar Quiz',
    grading: 'Your final grade is: {grade}%',
    badge: 'download \n badge',
  },
  nav: {
    home: 'Home',
    train: 'Train',
    learn: 'Learn',
    retain: 'Retain',
    directory: 'Directory',
    showRoom: 'Showcases',
    showcases: 'Showcases',
    offers: 'Offers',
    promote: 'Promote',
    sell: 'Sell',
    info: 'Info',
    rewards: 'Rewards',
    media: 'Media',
    favorites: 'Favorites',
    contact: 'Meet the Team',
    reportCard: 'View Diploma',
    accountSettings: 'Account Settings',
    messages: 'Messages',
    search: 'Search',
  },
  contentHeaders: {
    train: 'Train',
    retain: 'Retain',
    subapps: '{program_name} Partner Modules',
    maintrainings: 'The Foundation',
    subtrainings: 'Specializations',
  },
  pageDescriptions: {
    train: 'Educate, engage and become the expert.',
    showroom: '',
    retain:
      'Congratulations on completing your training! You have now unlocked your go-to resource for retaining your expert knowledge and enabling your sales efforts. Use this area to expertly answer a product question or even as an impromptu sales presentation — anytime, anywhere and from any device.',
    promote:
      'Share these items to ignite interest and start a conversation with clients and prospects.',
    sell: 'Answer client questions and close the sale like a pro with deep resources and targeted sales support.',
    favorites: 'Check out your personally favorited content',
    search: 'Look through all content',
    subapps: '',
    maintrainings: 'Complete these essential modules to earn your certificate.',
    subtrainings:
      'Up your game and earn a badge for each specialization module below.',
  },
  general: {
    chapter: 'Chapter',
    next: 'Next',
    yes: 'Yes',
    no: 'No',
    previous: 'Previous',
    submit: 'Submit',
    back: 'Back',
    close: 'Close',
    page: 'Page',
    search: 'Search',
    logIn: 'Log in',
    logOut: 'Log Out',
    viewItem: 'View {type}',
    imageNotFound: 'Image not found',
    noResultsFor: 'No results have been found for: {{query}}',
    noFavorites: "You don't have any favorites yet.",
    noMessages: "You haven't received any messages yet!",
    resultsFor: 'Results for: {{query}}',
    showAll: 'Show all',
    connectionError: 'Connection error',
    alreadyExists: 'Already exists',
    pageNotFound: '404 Page Not Found!',
    oops: 'Uh oh...',
    overview: 'Return to overview',
    complete: 'Continue',
    courseComplete: 'Chapter Complete!',
    chapterComplete: 'Chapter Completed!',
    message: '{count} Message',
    messagePlural: '{count} Messages',
    comingSoon: 'Coming Soon',
  },
  itemTypes: {
    image: 'Image',
    brochure: 'Collection',
    layout: 'Layout',
    web: 'Website',
    pdf: 'PDF',
    carousel: 'Collection',
  },
  questions: {
    dials: 'Rotate the dials to match the answer',
    fitb: 'Fill in the blank(s)',
    flip: 'Change the number to match the answer',
    multipleChoice: 'Pick the right answer(s)',
    slider: 'Pick the right answer using the slider',
    map: 'Answer the question by tapping the right location on the map',
    dropdown: 'Choose...',
    true: 'True',
    false: 'False',
  },
  reportCard: {
    download: 'Download',
    email: 'Email',
    print: 'Print',
  },
  cookies: {
    consent: 'AGREE',
    optout: 'Opt-out',
    settings: 'Privacy Settings',
    message:
      "You haven't told us anything about your data privacy preferences! That's ok, but we'd like to offer you the best experience using the Sales Companion.",
    disabled: 'It looks like you have disabled the use of cookies.',
    use: 'The {{appName}} requires the use of cookies to deliver you the best experience.',
    details: 'What are the cookies used for?',
    enable: 'See how to enable your cookies {{here}}.',
    here: 'here',
  },
  notLoggedIn: {
    super: "You're not logged in",
    title: 'You need to be logged in to view this content',
    guest: 'Guest',
  },
  demo: {
    message:
      'This website is a demo of the final product. It is currently in-development and not a complete product.',
    consent: 'Understood!',
  },
  share: {
    header: 'Share this resource on your favorite social media!',
    download: 'Download',
  },
  sharing: {
    copyURL: 'Copy Link',
    copied: 'Copied',
  },
  breadCrumbs: {
    page: 'Page',
  },
  onMobile: {
    header:
      "It looks like you're trying to access the {appName} app from a mobile device",
    body: 'To download this program simply visit your app store and search for {appName} or click one of the buttons below',
    benefits: {
      header: 'This will provide you with:',
      1: 'Learn, Promote & Sell on the Go',
      2: 'Multi-media Training Across Devices',
      3: 'Certificate of Completion',
      4: 'Ready-made Sales Presentations',
      5: 'High-impact Promotional Materials',
      6: 'Real-time Product Directory',
      7: 'Timely News & Updates',
    },
  },
  directoryView: {
    search: 'Search...',
    amountOfResults: 'Amount of results:',
    filter: 'Filter',
    filters: 'Filters:',
    subFilter: 'Sub Filter',
    resetFilters: 'Reset Filters',
    showResults: 'Show Results',
    noResults: 'No results found. Please try with a different search.',
    resetMap: 'Reset Map to Start >',
    viewNow: 'View Now >',
  },
  directory: {
    artsentertainment: 'Arts & Entertainment',
    conventionservices: 'Convention Services',
    divingsnorkeling: 'Diving & Snorkeling',
    film: 'Film',
    hotels: 'Hotels',
    lgbtgymsandspas: 'LGBT+: Gyms and Spas',
    lgbtshopping: 'LGBT+: Shopping',
    lgbtwheretostay: 'LGBT+: Where to Stay',
    multiculturaldining: 'Multicultural: Dining',
    multiculturalnightlife: 'Multicultural: Nightlife',
    nightlife: 'Nightlife',
    petfriendly: 'Pet-Friendly',
    restaurants: 'Restaurants',
    shopping: 'Shopping',
    spas: 'Spas',
    sports: 'Sports',
    transportation: 'Transportation',
    venues: 'Venues',
    waterways: 'Waterways',
    waystoplay: 'Ways to Play',
    weddinglocations: 'Wedding Locations',
    weddingvendors: 'Wedding Vendors',
  },
  preregisterview: {},
  custom: {
    splitUsers: 'I Am A ...',
    brandAmbassador: 'Brand Ambassador',
    travelPro: 'Travel Professional',
  },
  rewards: {
    rewards: 'Rewards',
    title: 'Welcome to the Rewards Center',
    subheader: 'Track and Share Booking Submissions and Rewards',
    subTitle:
      'We’re giving you a chance to win rewards for becoming a specialist with our program, and booking travel to {destination_name}!',
    body: 'Book travel to {destination_name} for your chance to win! Enter your bookings for eligibility to earn an Introductory Incentive Reward of $5 US/CAN E-gift Card.',
    item1:
      'After your first confirmed booking of 4-nights or more, (for an individual reservation), for a minimum of two (2) passengers, at a qualifying hotel/resort. (Cruises do not qualify.)',
    item2:
      'Offer valid after Essential Modules of the {program_name} are completed.',
    link1: 'Have you booked {destination_name}? ',
    link2: 'If so, submit your booking here.',
    button: 'Submit your booking',
    products: 'Marketplace',
    viewAllBookings: 'Bookings',
    viewLeaderboard: 'Leaderboard',
    viewDashboard: 'Points Dashboard',
    viewRewards: 'Overview',
    overview: {
      title:
        'Earn Points & Cash rewards for your {client_name} training, sharing and bookings.*',
      grand: 'Cash Rewards for Every Booking More Than 3 Nights',
      grandPrize: 'USD $50 per every 3-5 nights stay',
      grandPrizeSecond: 'USD $100 per every 6+ Nights stay',
      first: 'Monthly Prizes',
      firstPrize:
        'Chances to win part of $500 for the travel advisors booking the highest number of guests to any {client_name} property.',
      second: 'Grand Prizes',
      secondPrize:
        'Rooms, Upgrades, Site inspection FAMs., Swag, and more to surprise and delight our valued advisors.',
      choosen: 'Point Based Redemption Marketplace',
      choosenPrize:
        'Use point that you earn along the way for ALL activities including booking submissions, training, and sharing ccollateral with your clients.',
      valid:
        "*Bookings entered are valid only after client's travel is completed.",
    },
    home: {
      entries: 'Current Entries',
      trainingAchievements: 'TRAINING ACHIEVEMENTS',
      trainingAchievementsText:
        'Track your training progress, certifications, and metallic rewards status on this page. You’ll also be able to download and share your diploma, as well as any badges you’ve earned.',
      bookingContests: 'BOOKINGS DASHBOARD',
      bookingContestsText:
        'Easily track and manage current booking submissions on the Bookings Dashboard. ',
      submitBooking: 'SUBMIT BOOKINGS',
      submitBookingText:
        'This is where you’ll submit bookings for inclusion in booking contests.',
      currentContest: 'CURRENT CONTEST',
      currentContests: 'CURRENT CONTESTS',
      contestHeader: 'Win cash prizes on bookings each month!',
      contestPrizes:
        'Enter your hotel, ground services, and car rental bookings each month for a chance to win three great prizes:',
      contestPrize1: 'One (1) $250 Gift Card',
      contestPrize1Description:
        ' will be awarded to the advisor with the most bookings/entries* for the month',
      contestPrize2: 'Two (2) $100 Gift Cards',
      contestPrize2Description:
        ' will be awarded to two lucky advisors through a random drawing',
      contestConditions:
        '*One (1) Entry will be given to each qualifying booking:',
      contestLodging: 'Lodging: ',
      contestCondition1: 'Bookings must be 3 nights or more',
      contestGroundServices: 'Ground Services:  ',
      contestCondition2:
        '3 services or more (e.g., Meet & Greet, transfer, and sightseeing)',
      contestCarRental: 'Car Rental: ',
      contestCondition3: 'must be 3 days or more',
      contestStartEarning: 'Start earning your chances to win by ',
      contestEnterBookings: 'entering your bookings',
      contestNow: ' now!',
      contestSeeOther: 'See other ',
      contestTerms: 'Terms & Conditions',
    },
    bookingRewardsView: {
      title: 'Marketplace',
    },
    bookingsView: {
      title: 'Bookings',
    },
    leaderboardScreen: {
      title: 'POINTS \n Leaderboard',
      earnedpts: 'MY POINTS EARNED​:',
      pointsWall: 'POINTS TOP 5 TRACKER​:',
      startEarning: "Start now earning XP's and join the leaderboard!",
      prizes: 'Prizes',
      tAndC: 'Terms and Conditions apply*',
      pointsOverview: {
        title: 'How to earn points',
        booths: 'Visit Exhibitor Showcases',
        breakoutSessions: 'Attend Breakout Sessions & Destination Spotlights',
        trainingSessions: 'Complete a Training Chapter',
        adventureSpotlights: 'Family Travel Tips',
        share: 'Sharing Content',
        shareMax: '(up to {maxSharePoints} points)',
        shareInfo:
          'Sharing is counted by sharing booth content to Twitter and Facebook or sharing the entire booth with colleagues or clients.',
        viewVideo: 'View Video',
      },
    },
    termsConditions: {
      title: 'Terms & Conditions',
      button: 'Return to Rewards',
      textContent: {
        eligibilityDescription:
          'Only graduates of the {appName} course are eligible and entitled to participate, earn entries, and redeem rewards.',
        eligibilityRule:
          'The bookings contest is valid for Travel Advisors only, not agencies/groups/companies. Participation is individual and valid wherever you work or may work, for as long as this program is in effect.',
        qualifyingDescription:
          'Only Lodging and Ground Services, including Car Rental, qualify as bookings to earn entries. Air and Cruise bookings do not qualify.',
        fiscalResponsibilityRules: {
          1: 'You must represent yourself and act as a legitimate travel advisor or seller of travel, member of ASTA, ARC, IATA, CLIA, or part of a Host Agency, Travel Consortium, or Travel Conglomerate duly licensed under the laws of your country of residence and subject to the laws of the United States of America and the laws of the Commonwealth of {destinationName}.',
          2: 'You are responsible for reporting any sales revenues to the proper authorities of your country, or those of the country where the travel originated. Awards may or not be exempt according to the laws of your country or that of the passenger where travel originated.',
          3: 'Other conditions may apply.',
          4: 'This is an adhesion agreement, Participants accept the terms and conditions of {clientName}, and all its decisions as final.',
          5: 'Any participants misrepresentations, the submission of false information, or any act considered misconduct will forfeit participation and all earned points and may risk liability for prosecution under the law.',
          6: 'Participants agree that the prevailing law is that of the Commonwealth of {destinationName} for all purposes relating to this program.',
          7: 'All terms and conditions are subject to change without notice.',
        },
        entrys: {
          1: 'Earn one entry for each lodging booking of 3 nights or more.',
          2: 'Earn one entry for 3 or more Ground Services booked (e.g., Meet & Greet, transfer, sightseeing).',
          3: 'Earn one entry for each Car Rental booking of 3 days or more.',
          4: 'Bookings must be entered on the Submit Bookings page in the Rewards Center and may be tracked in the Bookings Dashboard.',
          5: 'Valid bookings entered between the first and last day of the month will be eligible to win the monthly cash prizes.',
          6: 'The travel advisor with the highest number of qualified bookings each month will be awarded {span}.',
          7: 'A random drawing for {span} will be made on or close to the first of the month for travel advisors entering qualified bookings during the month prior.',
          8: 'All winners will be notified and receive their gift cards by email.',
          span: {
            6: 'one (1) $250 Gift Card',
            7: 'two (2) $100 Gift Cards',
          },
        },
      },
      sectionHeaders: {
        eligibility: 'Eligibility',
        conditions: 'Conditions',
        fiscalResponsibility: 'Fiscal Responsibility',
      },
    },
    dashboardView: {
      title: 'Bookings Dashboard',
      subtitle: 'Track and Manage Your Booking Entries Here.',
      badge: 'Badges',
      activity: 'Bookings Dashboard',
      manage: 'Manage Bookings',
      manageSub:
        'Sort using buttons above and click any record to manage submission details. All pending entries will be verified within 72 hours. ',
      noBookings: 'There are no records to display.',
      state: {
        approvedEntries: 'Approved Entries',
        pendingEntries: 'Pending Entries',
        declinedEntries: 'Declined Entries',
        viewAll: 'View All',
      },
    },
    bookingForm: {
      title: 'Booking Submission Form',
      subTitle: 'Enter your booking:',
      required: '* Indicates a required field',
      email: 'Agent Email',
      agentFirstName: 'Agent First Name',
      agentLastName: 'Agent Last Name',
      company: 'Company name',
      iata: 'IATA/CLIA #',
      stateProvince: 'State/ Province',
      postalCode: 'Zip Code *',
      country: 'Country',
      bookingNumber: 'Booking Confirm Number',
      numberOfGuests: 'Number of Adult Guests',
      bookingDate: 'Booking Date',
      tourOperator: 'Tour Operator / Booking Method',
      firstName: 'First Name',
      lastName: 'Guest Last Name',
      accommodation: 'Resort/Hotel/Accommodations booked',
      select: 'Select an option',
      wholesaler:
        'Wholesaler Name (if applicable): if this is a direct booking, enter NONE',
      arrivalDate: 'Check-In Date',
      departureDate: 'Check-Out Date',
      lengthOfStay: 'Length of Stay (in Nights)',
      reservationNumber: 'Reservation Number',
      rooms: 'Number of Rooms',
      stay: 'Length of Stay (in Nights)',
      airline: 'Airline / Carrier (2- digit code)',
      originAirport: 'Origin Gateway (3- letter airport code)',
      destination: 'Destination/ island (3- letter airport code)',
      cost: 'Total Cost of Booking (only use decimals)',
      file: 'RezSnap™ Proof Upload',
      disclaimer: '* Required fields',
      button: 'Submit your booking',
      sub: 'Your information',
      sub2: 'Booking information',
      guests: 'Number of Passengers',
    },

    thankYouPage: {
      thanks: 'Thank you',
      congrats: 'Congratulations, ',
      body: 'your booking has been received and sent to the campaign supervisor for verification.',
      link: 'Please note to be a winner, you must have completed the Essential Modules of the Bahamas Specialist Program',
    },
    menu: {
      home: 'Rewards\nCenter',
      achievements: 'Training\nAchievements',
      bookings: 'Bookings\nDashboard',
      form: 'Submit\nBookings',
    },
  },
  badgeView: {
    title: 'Training Achievements',
    subtitle:
      'Track your training progress, certifications, and metallic rewards status on this page. You’ll also be able to download and share your {program_name_short} diploma, as well as any badges you’ve earned.',
    badgeDisplayTitle: 'Metallic Achievement Status',
    badgeAchievement:
      'You have achieved {rank} Status! Click the icon on the right to view and share your status.',
    bronze: 'Bronze',
    silver: 'Silver',
    gold: 'Gold',
    platinum: 'Platinum',
    complete: 'COMPLETE',
    diploma: 'Diploma',
    chapterBadges: 'Specialization Badges',
    partnerBadges: 'Partner Badges',
  },
  badgeDisplay: {
    status: 'Training Achievement Status',
  },
  categories: {
    all: 'All',
    volunteeropportunities: 'Volunteer Opportunities',
    sportshobbiesactivities: {
      sportshobbiesactivities: 'Sports, Hobbies & Activities',
      scubadiving: 'Scuba Diving',
      snorkeling: 'Snorkeling',
      sup: 'SUP / Paddleboarding',
      fishing: 'Fishing',
      camping: 'Camping',
      trekkinghiking: 'Trekking & Hiking',
      kayaking: 'Kayaking',
      riverrafting: 'River Rafting',
      rivertubing: 'River Tubing',
      ziplining: 'Ziplining',
      miniaturegolf: 'Miniature Golf',
      jetskiing: 'Jet Skiing',
      otherwatersports: 'Other Watersports',
      rappelling: 'Rappelling',
      bowling: 'Bowling',
      recreationalwalking: 'Recreational Walking',
      surfinglessons: 'Surfing Lessons',
      golf: 'Golf',
      biking: 'Biking',
      bikingtrails: 'Biking Trails',
      paintball: 'Paintball',
      fourwheeleratvs: '4-Wheeler / ATVs',
      surfingequipment: 'Surfing Equipment',
      horsebackriding: 'Horseback Riding',
      sailing: 'Sailing',
      birding: 'Birding',
      surfspots: 'Surf Spots',
      rockclimbing: 'Rock Climbing',
      gokarts: 'Go-Karts',
      boatrentalscharters: 'Boat Rentals & Charters',
      cavetubing: 'Cave Tubing',
      windsurfing: 'Windsurfing',
      kitesurfing: 'Kitesurfing / Kiteboarding',
      hanggliding: 'Hang Gliding',
      scenicflights: 'Scenic Flights',
      parasailing: 'Parasailing',
      skydiving: 'Skydiving',
      balloonrides: 'Balloon Rides',
    },
    landmarkspointsofinterest: {
      landmarkspointsofinterest: 'Landmarks & Points of Interest',
      architecturalsites: 'Architectural Sites',
      nationalregister: 'U.S. National Register of Historic Places Listings',
      beaches: 'Beaches',
      playgrounds: 'Playgrounds',
      townhalls: 'Town Halls',
      housesofimportantfigures: 'Houses of Important Figures',
      photospotsviewpoints: 'Photo Spots / Viewpoints',
      citytownplazas: 'City / Town Plazas',
      ruinsabandonedplaces: 'Ruins & Abandoned Places',
      fortresses: 'Fortresses',
      historicwalkingareas: 'Historic Walking Areas',
      publicparks: 'Public Parks',
      rivers: 'Rivers',
      lakes: 'Lakes',
      archaeologicalsites: 'Archaeological Sites',
      lighthouses: 'Lighthouses',
      bays: 'Bays',
      churchesreligiouscenters: 'Churches & Religious Centers',
      libraries: 'Libraries',
      statues: 'Statues',
      forests: 'Forests',
      mountains: 'Mountains',
      swimmingholes: 'Swimming Holes',
      boardwalks: 'Boardwalks',
      naturalsprings: 'Natural Springs',
      caves: 'Caves',
      indigenoussites: 'Indigenous Sites',
      monuments: 'Monuments',
      bioluminescentbays: 'Bioluminescent Bays',
      coffeeplantations: 'Coffee Plantations',
      murals: 'Murals',
      canyons: 'Canyons',
      inscribedrocks: 'Inscribed Rocks',
      waterfalls: 'Waterfalls',
      theaters: 'Theaters',
      universitiesschools: 'Universities & Schools',
      visitorcenters: 'Visitor Centers',
      castles: 'Castles',
      legendsghosts: 'Legends & Ghosts',
      historicestates: 'Historic Estates',
      unescoheritagesites: 'UNESCO Heritage Sites',
      bridges: 'Bridges',
      islands: 'Islands',
      cays: 'Cays',
      marinasyachtclubs: 'Marinas / Yacht Clubs',
      cemeteriesmausoleums: 'Cemeteries & Mausoleums',
      lagoons: 'Lagoons',
      reefs: 'Reefs',
      towers: 'Towers',
      gardens: 'Gardens',
      farms: 'Farms',
      fountains: 'Fountains',
      ranches: 'Ranches',
      sculptures: 'Sculptures',
      dams: 'Dams',
      caverns: 'Caverns',
    },
    volunteeropportunities: {
      volunteeropportunities: 'Volunteer Opportunities',
      artsandculture: 'Arts & Culture',
      environment: 'Environment',
    },
    accommodations: {
      accommodations: 'Accommodations',
      bedandbreakfasts: 'Bed & Breakfasts',
      condosandapartmentrentals: 'Condos & Apartment Rentals',
      smallinnsguesthouses: 'Small Inns & Guest Houses',
      housevillarentals: 'House & Villa Rentals',
      hotels: 'Hotels',
      resorts: 'Resorts',
      homestays: 'Homestays',
      campgroundstentsites: 'Campgrounds - Tent Sites',
      campgroundstrailersites: 'Campgrounds - Trailer Sites',
      hostelsbackpackers: 'Hostels / Backpackers',
      uniquerentals: 'Unique Rentals',
      glamping: 'Glamping',
      paradores: 'Paradores',
      motels: 'Motels',
    },
    attractions: {
      attractions: 'Attractions',
      artgalleries: 'Art Galleries',
      amusementparks: 'Amusement Parks',
      waterparks: 'Water Parks',
      movietheaterscinemas: 'Movie Theaters / Cinemas',
      wildliferefugesnaturereserves: 'Wildlife Refuges & Nature Reserves',
      thermalpools: 'Thermal Pools',
      nationalparks: 'National Parks',
      naturecenters: 'Nature Centers',
      agritourism: 'Agritourism',
      distilleries: 'Distilleries',
      casinos: 'Casinos',
      eventticketing: 'Event Ticketing',
      escaperooms: 'Escape Rooms',
      horseracing: 'Horse Racing',
      botanicalgardens: 'Botanical Gardens',
      danceshows: 'Dance Shows',
    },
    dining: {
      dining: 'Dining',
      foodstands: 'Food Stands',
      chinchorros: 'Chinchorros',
      restaurants: 'Restaurants',
      pubssportsbars: 'Pubs & Sports Bars',
      cafeterias: 'Cafeterias',
      bistrosloungesgastropubs: 'Bistros, Lounges & Gastropubs',
      bakeriespastryshops: 'Bakeries / Pastry Shops',
      coffeeshops: 'Coffee Shops',
      foodtrucks: 'Food Trucks',
      specialtyfoodshops: 'Specialty Food Shops',
      delis: 'Delis',
      breweries: 'Breweries',
      fastfood: 'Fast Food',
      diners: 'Diners',
    },
    eventservices: {
      eventservices: 'Event Services',
      travelagencies: 'Travel Agencies',
      eventcoordinatorsmeetingplanners: 'Event Coordinators & Meeting Planners',
      eventmanagementcompanies: 'Event Management Companies',
      catering: 'Catering',
      airfreightpackagesshipping: 'Air Freight, Packages & Shipping',
      groupfriendlyactivitiestours: 'Group-Friendly Activities & Tours',
      tourgroundoperatorscharters: 'Tour & Ground Operators / Charters',
      trainingteambuildingcompanies: 'Training & Teambuilding Companies',
      weddingphotography: 'Wedding Photography',
      eventphotography: 'Event Photography',
      weddingplannerscoordinators: 'Wedding Planners & Coordinators',
      musiciansentertainers: 'Musicians & Entertainers',
      healthspaswellnessprograms: 'Health Spas / Wellness Programs',
      flowersdecoration: 'Flowers & Decoration',
      linenchairtablerentals: 'Linen, Chair & Table Rentals',
      signsdisplaysgraphicsprinting: 'Signs & Displays / Graphics / Printing',
      workshopseminarspeakers: 'Workshop & Seminar Speakers',
      audiovisual: 'Audiovisual',
      lightsoundeffects: 'Light & Sound Effects',
      serviceprofessionals: 'Service Professionals',
      hairmakeup: 'Hair & Makeup',
      foreignlanguagespecialists: 'Foreign Language Specialists',
      promoitemsawardsgifts: 'Promo Items, Awards & Gifts',
      tempstaffingemploymentservices: 'Temp Staffing & Employment Services',
      groupfriendlyattractions: 'Group-Friendly Attractions',
      destinationmanagementcompanies: 'Destination Management Companies',
      musicentertainmentpromoters: 'Music & Entertainment Promoters',
      webcastinginternetservices: 'Webcasting & Internet Services',
      finepastries: 'Fine Pastries',
      expositiontradeshowcontractors: 'Exposition & Tradeshow Contractors',
      travelwholesalers: 'Travel Wholesalers',
      securitysystemcompanies: 'Security System Companies',
      officesupplies: 'Office Supplies',
      computerrentaldataprocessingit: 'Computer Rental, Data Processing & IT',
    },
    eventvenues: {
      eventvenues: 'Event Venues',
      accommodationonsite: 'Accommodation On Site',
      meetingrooms: 'Meeting Rooms',
      conferencecenters: 'Conference Centers',
      groupdiningvenues: 'Group Dining Venues',
      noaccommodationonsite: 'No Accommodation on Site',
      ceremonyvenues: 'Ceremony Venues',
      receptionvenues: 'Reception Venues',
      conventioncenters: 'Convention Centers',
      ballrooms: 'Ballrooms',
      banquetvenues: 'Banquet Venues',
      theatershowvenues: 'Theater / Show Venues',
      concertvenues: 'Concert Venues',
      stadiums: 'Stadiums',
    },
    medicaltourism: {
      medicaltourism: 'Medical Tourism',
      dental: 'Dental',
      hospitals: 'Hospitals',
    },
    museums: {
      museums: 'Museums',
      historymuseums: 'History Museums',
      artmuseums: 'Art Museums',
      sciencemuseums: 'Science Museums',
      archaeologymuseums: 'Archaeology Museums',
      agriculturemuseums: 'Agriculture Museums',
      musicmuseums: 'Music Museums',
      folkloreindigenousmuseums: 'Folklore & Indigenous Museums',
    },
    nightlife: {
      nightlife: 'Nightlife',
      danceclubs: 'Dance Clubs',
      karaoke: 'Karaoke',
      sportsbars: 'Sports Bars',
      comedyclubs: 'Comedy Clubs',
      livemusic: 'Live Music',
      lounges: 'Lounges',
      cocktailbars: 'Cocktail Bars',
      cigarbars: 'Cigar Bars',
      speakeasies: 'Speakeasies',
      gaybars: 'Gay Bars',
      winebars: 'Wine Bars',
    },
    shopping: {
      shopping: 'Shopping',
      clothingstores: 'Clothing Stores',
      specialtyshops: 'Specialty Shops',
      sportsoutdoorsoutfitters: 'Sports / Outdoors Outfitters',
      giftshops: 'Gift Shops',
      shoppingcentersplazas: 'Shopping Centers / Plazas',
      artsandcrafts: 'Arts & Crafts',
      madeinpuertorico: 'Made in {destination_name}',
      grocerystores: 'Grocery Stores',
      malls: 'Malls',
      jewelrystores: 'Jewelry Stores',
      departmentstores: 'Department Stores',
      fleamarkets: 'Flea Markets',
      openairmarkets: 'Open-Air Markets',
      boutiques: 'Boutiques',
      farmersmarkets: "Farmers' Markets",
      outlets: 'Outlets',
    },
    sportsmarketing: {
      sportsmarketing: 'Sports Marketing',
      associationsfederations: 'Associations & Federations',
      baseballvenues: 'Baseball Venues',
      basketballvenues: 'Basketball Venues',
      swimmingvenues: 'Swimming Venues',
      tennisvenues: 'Tennis Venues',
      trackandfieldvenues: 'Track & Field Venues',
      volleyballvenues: 'Volleyball Venues',
      soccerfootballvenues: 'Soccer / Football Venues',
      golfvenues: 'Golf Venues',
      softballvenues: 'Softball Venues',
      fishingtournamentvenues: 'Fishing Tournament Venues',
      martialartsvenues: 'Martial Arts Venues',
      skateboardingvenues: 'Skateboarding Venues',
      sportspromoters: 'Sports Promoters',
    },
    tours: {
      tours: 'Tours',
      adventuretours: 'Adventure Tours',
      guidedtours: 'Guided Tours',
      boattours: 'Boat Tours',
      cavetours: 'Cave Tours',
      natureecotours: 'Nature & Eco Tours',
      sightseeingtours: 'Sightseeing Tours',
      studentyouthtours: 'Student & Youth Tours',
      culturaltours: 'Cultural Tours',
      biketours: 'Bike Tours',
      historicaltours: 'Historical Tours',
      foodtours: 'Food Tours',
      walkingtours: 'Walking Tours',
      agriculturaltours: 'Agricultural Tours',
      shoppingtours: 'Shopping Tours',
      nighttours: 'Night Tours',
      drivingtours: 'Driving Tours',
      distillerytours: 'Distillery Tours',
      bustrolleytours: 'Bus & Trolley Tours',
      motorcycletours: 'Motorcycle Tours',
    },
    transportation: {
      transportation: 'Transportation',
      airports: 'Airports',
      airlines: 'Airlines',
      buses: 'Buses',
      luxurytransportation: 'Luxury Transportation',
      privatetransportation: 'Private Transportation',
      carvanrentals: 'Car / Van Rentals',
      aircraftchartershelicopter: 'Aircraft Charters - Helicopter',
      taxis: 'Taxis',
    },
    wellness: {
      wellness: 'Wellness',
      gymsfitnesscenters: 'Gyms & Fitness Centers',
      yoga: 'Yoga',
      spas: 'Spas',
      meditation: 'Meditation',
    },
  },
  search: {
    pages: 'Pages',
    resources: 'Resources',
  },
};
